import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { BusCheckListService } from '../../secure/bus-checker/_services/bus-check-list.service';
import * as BusCheckActions from '../actions/bus-check-list.actions';

@Injectable()
export class BusCheckEffects {
  constructor(
    private actions$: Actions,
    private busCheckService: BusCheckListService
  ) {
  }

  loadBusChecks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusCheckActions.loadBusChecks),
      mergeMap(() =>
        this.busCheckService.getAllBusCheckListTemplates().pipe(
          map((busChecks) => BusCheckActions.loadBusChecksSuccess({ busChecks })),
          catchError((error) => of(BusCheckActions.loadBusChecksFailure({ error })))
        )
      )
    )
  );

  addBusCheck$ = createEffect(() =>
  this.actions$.pipe(
    ofType(BusCheckActions.addBusCheck),
    mergeMap(({ busCheck }) =>
      this.busCheckService.addRegionalTopic(busCheck).pipe(
        map(() => BusCheckActions.loadBusChecks()),
        catchError((error) => of(BusCheckActions.loadBusChecksFailure({ error })))
      )
    )
  )
);

  updateBusCheck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusCheckActions.updateBusCheck),
      mergeMap(({ busCheck }) =>
        this.busCheckService.updateBusCheckListTemplate(busCheck.id, busCheck).pipe(
          map(() => BusCheckActions.loadBusChecks()),
          catchError((error) => of(BusCheckActions.loadBusChecksFailure({ error })))
        )
      )
    )
  );

  deleteBusCheck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusCheckActions.deleteBusCheck),
      mergeMap(({ id }) =>
        this.busCheckService.deleteBusCheckListTemplate(id).pipe(
          map(() => BusCheckActions.loadBusChecks()),
          catchError((error) => of(BusCheckActions.loadBusChecksFailure({ error })))
        )
      )
    )
  );

  // Efecto para Botón 1: Master Template
  addMasterTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusCheckActions.addMasterTemplate),
      mergeMap(({ busCheck }) =>
        this.busCheckService.addMasterTemplate(busCheck).pipe(
          map(() => BusCheckActions.loadBusChecks()),
          catchError((error) => of(BusCheckActions.addMasterTemplateFailure({ error })))
        )
      )
    )
  );

  // Efecto para Botón 2: Setup desde Master Template
  setupFromMasterTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusCheckActions.setupFromMasterTemplate),
      mergeMap(({ language, regionId }) =>
        this.busCheckService.setupFromMasterTemplate(language, regionId).pipe(
          map(() => BusCheckActions.loadBusChecks()),
          catchError((error) => of(BusCheckActions.setupFromMasterTemplateFailure({ error })))
        )
      )
    )
  );

  // Efecto para Botón 3: Añadir tema regional
  addRegionalTopic$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusCheckActions.addRegionalTopic),
      mergeMap(({ busCheck }) =>
        this.busCheckService.addRegionalTopic(busCheck).pipe(
          map(() => BusCheckActions.loadBusChecks()),
          catchError((error) => of(BusCheckActions.addRegionalTopicFailure({ error })))
        )
      )
    )
  );
}